export const TRANSFER_REGISTRATION_FORM = 'TRANSFER_REGISTRATION_FORM';
export const PRELOADER = 'TRANSFER_REGISTRATION_PRELOADER';
export const LOADER = 'TRANSFER_REGISTRATION_LOADER';
export const SEARCH_USER_BY_EMAIL_ACTION = 'SEARCH_USER_BY_EMAIL_ACTION';
export const SAVE_TRANSFER_REGISTRATION_ACTION = 'SAVE_TRANSFER_REGISTRATION_ACTION';
export const DELETE_TRANSFER_REGISTRATION_ACTION = 'DELETE_TRANSFER_REGISTRATION_ACTION';
